<ng-template #content *ngIf="current$ | async as current">
  <div class="modal-header" [ngClass]="{ 'bg-danger text-light': current.critical === true }">
    <h4 class="modal-title" id="modal-basic-title">{{ current.title }}</h4>
  </div>
  <div class="modal-body" [innerHTML]="current.body"></div>
  <div class="modal-footer" [ngClass]="{ 'justify-content-center': !current.onCancel }">
    <button
      type="button"
      [disabled]="isExecuting"
      class="btn px-4"
      [ngClass]="{
        'btn-danger': current.onCancel,
        'btn-success': !current.onCancel,
      }"
      (click)="exec(current.onConfirm)">
      <span class="material-icons spin" *ngIf="isExecuting">sync</span>
      {{ current.onCancel ? 'Ja' : (current.confirmText ?? 'Okej!') }}
    </button>
    <button
      autofocus
      type="button"
      [disabled]="isExecuting"
      *ngIf="current.onCancel"
      class="btn btn-outline px-4"
      (click)="exec(current.onCancel)">
      Nej
    </button>
  </div>
</ng-template>
